export default __webpack_public_path__ + "static/media/mehul.08104d49.jpeg";